import * as z from "zod";

import { OrganizationEntitlementState } from "@workspace/billing";
import {
  selectOrganizationSubscriptionSchema,
  selectCustomerSchema,
  selectOrderSchema,
  selectSubscriptionSchema,
} from "@workspace/db/schema";

export const getBillingSummaryResponseSchema = z.array(
  selectCustomerSchema.extend({
    subscriptions: z.array(selectSubscriptionSchema),
    orders: z.array(selectOrderSchema),
  }),
);

export const createOrganizationBillingCheckoutSchema = z.object({
  variant: z.object({
    id: z.string(),
  }),
  redirect: z.object({
    success: z.url(),
    cancel: z.url(),
  }),
});

export const createOrganizationBillingCheckoutResponseSchema = z.object({
  paypalSubscriptionId: z.string(),
  paypalPlanId: z.string(),
  approvalUrl: z.string().nullable(),
  plan: z.string(),
});

export const getOrganizationBillingSubscriptionResponseSchema = z.object({
  subscription: selectOrganizationSubscriptionSchema.nullable(),
});

export const getOrganizationBillingStatusQuerySchema = z.object({
  subscription_id: z.string().optional(),
});

export const organizationCapabilitiesSchema = z.object({
  createSurveys: z.boolean(),
  viewPhraseLibrary: z.boolean(),
  viewStructureLibrary: z.boolean(),
  useBundledDefaultTemplate: z.boolean(),
  useAiGeneration: z.boolean(),
  exportReports: z.boolean(),
  uploadTemplates: z.boolean(),
  editPhraseLibrary: z.boolean(),
  editStructureLibrary: z.boolean(),
});

export const organizationEntitlementSchema = z.object({
  state: z.enum([
    OrganizationEntitlementState.GUEST_TRIAL,
    OrganizationEntitlementState.PAID,
    OrganizationEntitlementState.SUSPENDED_EXPIRED,
  ]),
  plan: z.string().nullable(),
  subscriptionStatus: z.string().nullable(),
  capabilities: organizationCapabilitiesSchema,
});

export const getOrganizationBillingStatusResponseSchema = z.object({
  subscription: selectOrganizationSubscriptionSchema.nullable(),
  status: z.string().nullable(),
  annualAllowance: z.number().int().nonnegative().nullable(),
  reportsUsed: z.number().int().nonnegative(),
  reportsRemaining: z.number().int().nonnegative().nullable(),
  entitlement: organizationEntitlementSchema,
});
